import { createComponent } from '../lib';
import { VmFile } from '@vime/core';
import { define } from '../lib';
define('vm-file', VmFile);
;
export default createComponent('vm-file', new Set(['willAttach', 'crossOrigin', 'preload', 'poster', 'mediaTitle', 'controlsList', 'autoPiP', 'disablePiP', 'disableRemotePlayback', 'viewType', 'playbackRates', 'language', 'autoplay', 'controls', 'logger', 'loop', 'muted', 'playsinline', 'noConnect', 'paused', 'currentTime', 'volume', 'playbackReady', 'playbackStarted', 'currentTextTrack', 'hasCustomTextManager', 'isTextTrackVisible', 'shouldRenderNativeTextTracks']));
